export default "__VITE_ASSET__aIp0VC19__"